var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6953 34.8871V15.1125C17.6953 14.2224 18.4169 13.5 19.3079 13.5C19.6263 13.5 19.9367 13.5943 20.2028 13.7709L35.0325 23.6598C35.7735 24.154 35.9734 25.1546 35.4792 25.8956C35.3615 26.073 35.2091 26.2254 35.0317 26.3431L20.202 36.2287C19.4602 36.723 18.4605 36.523 17.9654 35.7821C17.7896 35.5168 17.6953 35.2056 17.6953 34.8871Z",
    fill: "url(#hinava_random_uuid_161617633760542353559487143903348284502)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9984 3.65625C30.6984 3.65625 36.0578 5.875 40.0891 9.90625C44.1203 13.9375 46.3391 19.2969 46.3391 24.9984C46.3391 30.6984 44.1203 36.0578 40.0891 40.0891C36.0578 44.1203 30.6984 46.3391 24.9984 46.3391C19.2969 46.3391 13.9375 44.1203 9.90625 40.0891C5.875 36.0578 3.65625 30.6984 3.65625 24.9984C3.65625 19.2969 5.875 13.9375 9.90625 9.90625C13.9375 5.875 19.2969 3.65625 24.9984 3.65625ZM24.9984 6.99063C15.0688 6.99063 6.99063 15.0688 6.99063 24.9984C6.99063 34.9266 15.0688 43.0047 24.9984 43.0047C34.9266 43.0047 43.0047 34.9266 43.0047 24.9984C43.0047 15.0688 34.9266 6.99063 24.9984 6.99063Z",
    fill: "url(#hinava_random_uuid_103226312655409892327893920458643336168)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_161617633760542353559487143903348284502",
    x1: 26.7229,
    y1: 13.5,
    x2: 26.7229,
    y2: 36.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_103226312655409892327893920458643336168",
    x1: 24.9977,
    y1: 3.65625,
    x2: 24.9977,
    y2: 46.3391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.dc0fe1c2ac73ee7984285c7cec98d605.svg";
export { ForwardRef as ReactComponent };